// extracted by mini-css-extract-plugin
export default {"base_link":"StyledNavLink_base_link__N1gJ6","active_link":"StyledNavLink_active_link__CULuv","inactive_link":"StyledNavLink_inactive_link__QiCkx"};